<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{lang[type]}}</h2>
    </header>
    <div class="main">
      <div class="content" v-html="content"></div>
      <div v-if="!content" class="no-data">
        <img src="@img/no-data.png" />
        <p>{{lang.nomore}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        content:'',
        title:"",
        type:'intro'
      }
    },
    computed: {
      ...mapState(['lang'])
    },
    created() {
      this.type = this.$route.query.type || 'intro';
      if(this.type=='intro'){
        this.title = this.lang.intro
      }else if(this.type=='hezuo'){
        this.title = this.lang.hezuo
      }else if(this.type=='rules'){
        this.title = this.lang.rules
      }else if(this.type=='zizhi'){
        this.title = this.lang.zizhi
      }
      this.getData()
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/index/introduce',{
          type:this.type
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.content = res.data.data.cont;
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              sessionStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.comfirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      },
    },
  }
</script>
<style type="text/css" scoped >
  .content{
    padding:12px;
    color:#666;
  }
</style>